<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-with-title heading-without-image" id="prologue-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Prologue</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">R</span>yker killed the call, and felt a sickly, unfamiliar feeling. Was it worry, sorrow, or guilt, or all three? He painstakingly searched the rest of the house. There was no fresh food or milk in the fridge, nothing to suggest she’d been there recently. All of her clothes and her few belongings appeared to be in place. There was no sign of a struggle, a break-in either.</p>
<p class="subsq">In a moment of doubt – or was it hope? – Ryker wondered whether maybe she’d walked out on him, run away to start a new life on her own. He couldn’t fathom why she would do that, but it was surely a better outcome than the other possibility. Could his going to Spain have caused her to leave him?</p>
<p class="subsq">He returned to the bedroom, looked in the bedside drawer. Found her passport in the name of Lisa Ryker.</p>
<p class="subsq">No, she hadn’t run. One way or another, Lisa was in trouble. Winter had already tracked them down, despite their best efforts at hiding. Ryker’s only conclusion was that someone else had found them.</p>
<p class="subsq">And Ryker hadn’t been there to protect her. He felt a flood of guilt. While he’d been busy chasing an old flame through Spain, the love of his life had come to harm.</p>
<p class="subsq">He didn’t know who was responsible or why, but he would do everything he could to find out. To save her.</p>
<p class="subsq">Ryker moved quickly through the house, collecting the few possessions he needed: weapons, IDs, money. After opening the front door, he then turned to look back at his home, a place he had truly believed would become his sanctum. <i>Their </i>sanctum.</p>
<p class="subsq">Whatever had happened to Lisa, he knew that dream was gone.</p>
<p class="subsq">Ryker flicked off the lights and stepped out into the night. He shut the door behind him, and walked away.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?26413237